/*
通用工具函数封装
*/
import {ElMessage, ElMessageBox} from 'element-plus'
import throttle from 'lodash/throttle'
import ResizeObserver from "resize-observer-polyfill";

/*
一维数组 树形结构结构化
@param  []         data            数据源
@param  id         id字段          默认 'id'
@param  rootId    父节点id值       默认 -1
@param  pid       父id            默认 'parentId'
@param  children  子节点字段       默认 'children'
*/
export function formatTrees(data = [], id = 'id', rootId = -1, pid = 'parentId', childNode = 'children') {
    let treeArr = [];
    let cloneList = JSON.parse(JSON.stringify(data));

    cloneList.forEach(item => {
        if (item[pid] === rootId) {
            const children = formatTree(cloneList, id, item[id]);
            if (children && children.length > 0) {
                item[childNode] = children;
            }
            treeArr.push(item);
        }
    });

    console.log(treeArr, 'treeArr');
    return treeArr;
}

export function formatTree(data = [], id = 'id', pid = 'parentId', childNode = 'children') {
    //  深拷贝源数据
    let cloneList = JSON.parse(JSON.stringify(data));

    var childObj = {};
    var nodeIds = {};
    var treeArr = [];

    cloneList.forEach(item => {
        let parentId = item[pid];
        if (!childObj[parentId]) {
            childObj[parentId] = [];
        }
        nodeIds[item[id]] = item;
        childObj[parentId].push(item);

        if (!nodeIds[parentId]) {
            treeArr.push(item);
        }
    })


    treeArr.forEach(elem => {
        // 组装树
        elem && buildTree(elem)
    })


    function buildTree(elem) {
        if (childObj[elem[id]]) {
            elem[childNode] = childObj[elem[id]];
        }
        if (elem[childNode]) {
            elem[childNode].forEach(item => {
                if (item) {
                    buildTree(item);
                }
            })
        }
    }

    return treeArr;
}


/*
通过子节点ID查找所有关联的父节点
@param  tree        []                树形数据
@param  id         string / number   子节点id值
@param  nodeId     进行匹配的id字段    默认 menuId
@param  pid       父id            默认 'parentId'
@param  rootId    根节点id值       默认 -1
*/
export function getTreeIds(tree, id, nodeId = 'menuId', pid = 'parentId', rootId = -1, treeIds = []) {
    for (let i = 0; i < tree.length; i += 1) {
        const item = tree[i]
        // 找到匹配的元素
        if (item[nodeId] === id) {
            treeIds.push(item[nodeId])
            // 因为可能在第一层就找到了结果，直接返回当前结果
            if (treeIds.length === 1) {
                return treeIds
            }
            return true
        }
        // 如果存在下级节点，则继续遍历
        if (item.children) {
            // 预设本次是需要的节点并加入到最终结果treeIds中
            treeIds.push(item[nodeId])
            const find = getTreeIds(item.children, id, nodeId, pid, rootId = -1, treeIds)
            // 如果不是false则表示找到了，直接return，结束递归
            if (find) {
                return treeIds
            }
            // 到这里，意味着本次并不是需要的节点，则在treeIds中移除
            treeIds.pop()
        }
    }

    // 没找到可匹配元素
    return false
}

// 根据子节点 逆向查询父节点
export function reverseQueryNode(config) {
    let {tree, id, nodeId = 'id', pid = 'parentId', treeIds = []} = config
    console.log(tree,'tree===')
    for (let i = 0; i < tree?.length; i += 1) {
        const item = tree[i]
        // 找到匹配的元素
        if (item[nodeId] === id) {
            treeIds.push(item)
            // 因为可能在第一层就找到了结果，直接返回当前结果
            if (treeIds.length === 1) {
                return treeIds
            }
            return true
        }
        // 如果存在下级节点，则继续遍历
        if (item.children) {
            // 预设本次是需要的节点并加入到最终结果treeIds中
            treeIds.push(item)
            let config = {
                tree: item.children,
                id,
                nodeId: 'id',
                pid: 'parentId',
                treeIds
            }
            const find = reverseQueryNode(config)
            // 如果不是false则表示找到了，直接return，结束递归
            if (find) {
                return treeIds
            }
            // 到这里，意味着本次并不是需要的节点，则在treeIds中移除
            treeIds.pop()
        }
    }

    // 没找到可匹配元素
    return false
}


/*
* 多个接口并行调用错误信息处理
* */
export const messageError = throttle((msg) => {
    ElMessage.error({
        showClose: true,
        message: msg
    })
}, 1000)

export const confirmError = throttle((message) => {
    ElMessageBox.alert(message, '报错信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
        customClass: 'errBox',
        dangerouslyUseHTMLString: true,  // 将 message 作为 HTML 片段处理
    })
}, 1000, true)

// 回显数据字典
export function selectDictLabel(data, value) {
    if (value === undefined) {
        return "";
    }
    let actions = [];
    Object.keys(data).some((key) => {
        if (data[key].value == ('' + value)) {
            actions.push(data[key].label);
            return true;
        }
    })
    if (actions.length === 0) {
        actions.push(value);
    }
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    if (value === undefined) {
        return "";
    }
    var actions = [];
    var currentSeparator = undefined === separator ? "," : separator;
    var temp = value.split(currentSeparator);
    Object.keys(value.split(currentSeparator)).some((val) => {
        var match = false;
        Object.keys(datas).some((key) => {
            if (datas[key].value == ('' + temp[val])) {
                actions.push(datas[key].label + currentSeparator);
                return match = true;
            }
        })
        if (!match) {
            return actions.push(temp[val] + currentSeparator);
        }
    })
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 视图尺寸变化
export function viewResize(config) {
    let dom = config?.dom || null
    let callback = config?.callback || null
    let isRemove = config?.isRemove || false
    if (!dom) return;

    const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
            const {width, height} = entry.contentRect;
            if (callback) {
                callback({width, height});
            }
        }
    });

    observer.observe(dom);

    // 解除对元素尺寸的监听
    if (dom && isRemove) {
        observer.unobserve(dom);
    }
}


export async function setImageSize(imgData, $event, pNode, imgNode) {
    const $tag = $event?.path || $event?.target
    const img = $tag?.[0] || $tag

    if (img) {
        let imgBox = pNode

        let imgBoxAspectRatio = imgBox.offsetWidth / imgBox.offsetHeight

        let imgEl = imgNode || img
        let imgAspectRatio = imgEl?.offsetWidth / imgEl?.offsetHeight

        imgData.setSize = imgAspectRatio / imgBoxAspectRatio > 1 ? 'width' : (imgAspectRatio / imgBoxAspectRatio < 1 && 'height' || '')
    }
}


function wrapUnitsWithSpan(str) {
    // 定义中文单位
    const units = ['兆', '亿', '万'];
    // 用于存储结果的数组
    let resultParts = [];
    // 用于存储当前位置的索引
    let index = 0;
  
    // 遍历字符串中的每个字符
    for (let i = 0; i < str.length; i++) {
      // 如果当前字符是单位之一，则在单位前后添加span标签，并分割字符串
      if (units.includes(str[i])) {
        // 添加前面的部分（如果有）
        if (index !== i) {
          resultParts.push(str.substring(index, i));
        }
        // 添加带span标签的单位
        resultParts.push(`<span class='unit'>${str[i]}</span>`);
        // 更新索引为单位之后的位置
        index = i + 1;
      }
    }
  
    // 添加剩余的部分（如果有）
    if (index < str.length) {
      resultParts.push(str.substring(index));
    }
  
    // 将所有部分连接成最终的字符串
    return resultParts.join('');
  }
  



export const   numberToChineseNumerical =function (num) {

    // 数字转为字符串，反转以便从最低位开始处理
    const strNum = num.toString().split('').reverse().join('');
    if(strNum.length<=4){
        return num
    }



    const units = ['万', '亿', '兆'];
    let result = '';
    let count = 0; // 计数单位的索引
    

    // 从左到右处理每四位数字
    for (let i = 0; i < strNum.length; i += 4) {
      const section = strNum.substring(i, i + 4); // 获取四位数字
      let temp=section.split('').reverse().join('')
      const sectionNum = parseInt(temp, 10); // 转换为整数


      if (temp.length > 0) {
        // 如果当前四位数大于0，则添加到结果中
        if(result.length){
            if(sectionNum>0){
                result = `${sectionNum}${units[count]}${result}`;
            }
            count++;
        }else{
            result = `${sectionNum}`;
        }
      } else {
        // 跳过连续的0
        continue;
      }
    }
  
    // 删除末尾的'万'或'亿'等单位（如果存在）
    result = result.replace(/(万|亿)$/, '');

    let bak=result

    if(bak.includes("万")){
        bak = bak.split("万");
        let t=bak[1]
        if(t==='0'){
            result=`${bak[0]}万`
        }
    }
    let bak2=result
    if(bak2.includes("亿") && !bak2.includes("万")){
        bak2 = bak2.split("亿");
        let t=bak2[1]
        if(t==='0'){
            result=`${bak2[0]}亿`
        }
    }


    const wrappedStr = wrapUnitsWithSpan(result);
    console.log(wrappedStr);
    return wrappedStr;
  }